import sha256 from 'crypto-js/sha256';
/**
 * Creates hash of the value
 */
export const createHash = (value) => sha256(encodeURI(value.replace(/\s/g, ''))).toString();
